export interface IdentityProviderConfiguration {
  /**
   * The id of the app configured in the authentication/identity provider
   */
  clientId: string
  /**
   * The url to redirect users to login via external identity providers
   */
  authorizeEndpoint: string
  /**
   * The endpoint used to exchange the authorization code for tokens
   */
  tokenEndpoint: string
}

export interface DiscoveryResponse {
  authorization_endpoint: string
  token_endpoint: string
}

export type IdentityProviderConfigurationCache = Record<string, IdentityProviderConfiguration>

/**
 * The length of the state param (random generated string).
 * This value is arbitrary as the documentation doesn't specify a max length.
 */
export const STATE_PARAM_LENGTH = 16

/**
 * The length of the generated code verifier needs to be between 43 and 128 chars.
 * https://datatracker.ietf.org/doc/html/rfc7636
 */
export const CODE_VERIFIER_PARAM_LENGTH = 43
